import * as React from 'react';

import { cn } from 'utils/cn';

const Skeleton = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('animate-pulse rounded-small bg-sidebar-accent', className)}
    {...props}
  />
));
Skeleton.displayName = 'Skeleton';

export { Skeleton };
